export default {
  GET_FAQ_ITEMS_REQUESTED: 'GET_FAQ_ITEMS_REQUESTED',
  GET_FAQ_ITEMS_SUCCEEDED: 'GET_FAQ_ITEMS_SUCCEEDED',
  GET_FAQ_ITEMS_FAILED: 'GET_FAQ_ITEMS_FAILED',
};
